import React, { useState, useContext } from "react";
import styled from "styled-components";
import { ThemeContext } from "styled-components";
import avatarWalkthroughs from "./data/avatar-walkthroughs";
import avatarAppVideos from "./data/avatar-app-videos";
import avatarPortalVideos from "./data/avatar-portal-videos";
import avatarBestPractices from "./data/avatar-best-practices";
import avatarEducation from "./data/avatar-education";
import fbbcWalkthroughs from "./data/fbbc-walkthroughs";
import fbbcPortalVideos from "./data/fbbc-portal-videos";
import fbbcAppVideos from "./data/fbbc-app-videos";
import fbbcEducation from "./data/fbbc-education";
import fbbcBestPractices from "./data/fbbc-best-practices";
import List from "./list";
import VideoPlayer from "./video-player";

const Page = styled.div``;

const Content = styled.div`
  padding: 120px 0 200px 0;
  margin: 0 auto;
`;

function Videos() {
  const theme = useContext(ThemeContext);
  const [showVideo, setShowVideo] = useState(false);
  const [video, setVideo] = useState("");

  const handleVideoClick = (data) => {
    setShowVideo(true);
    setVideo(data);
  };

  return (
    <Page>
      <Content>
        {theme.name === "AVATAR" ? (
          <>
            <List
              large
              title="Walkthroughs"
              data={avatarWalkthroughs}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Avatar Portal"
              data={avatarPortalVideos}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Avatar App"
              data={avatarAppVideos}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Avatar Nutrition Best Practices"
              data={avatarBestPractices}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Nutrition Education"
              data={avatarEducation}
              handleVideoClick={handleVideoClick}
            />
          </>
        ) : (
          <>
            <List
              large
              title="Walkthrough"
              data={fbbcWalkthroughs}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Fit Body Coaching Portal"
              data={fbbcPortalVideos}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Fit Body Nutrition App"
              data={fbbcAppVideos}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Fit Body Nutrition Education"
              data={fbbcEducation}
              handleVideoClick={handleVideoClick}
            />
            <List
              title="Fit Body Nutrition Best Practices"
              data={fbbcBestPractices}
              handleVideoClick={handleVideoClick}
            />
          </>
        )}
      </Content>
      <VideoPlayer
        video={video}
        open={showVideo}
        onClose={() => setShowVideo(false)}
      />
    </Page>
  );
}

export default Videos;